import { getWindow } from '../../../utils';

/** @type {Record<import('./index').TabID, import('./index').TabID>} */
export const TabName = {
    About: 'About',
    Services: 'Services',
    WorkExperience: 'WorkExperience',
    Portfolio: 'Portfolio',
    Reviews: 'Reviews',
    Testimonials: 'Testimonials',
};

/** @type {(tabId: import('./index').TabID, offset?: number) => void} */
export const scrollToTab = (tabId, offset = 0) => {
    const targetId = document.getElementById(tabId);
    if (targetId) {
        const { top } = targetId.getBoundingClientRect();
        const scrollTo = top + offset;
        if (getWindow()?.scrollBy) {
            getWindow().scrollBy({ top: scrollTo, behavior: 'smooth' });
        }
    }
};
